import type { FaireProductEntity } from "../../entity_types/product";

export const p_b54p69k5dz: FaireProductEntity = {
  token: "p_b54p69k5dz",
  type: "product",
  name: "Carnelian Crystal Mushroom",
  brandToken: "b_fak8czuqg9",
  brandName: "Mandala Gems",
  imageUrl:
    "https://cdn.faire.com/fastly/61099160125e3bd8a9ae2276722a67fd6b66cf85e4de89667360cf2ff4635a65.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7d6ec402f9cf7b83310ee8e1ae2b2a1029c0ca5816fc47dcc6f599349bfaa375.jpeg",
    "https://cdn.faire.com/fastly/9dbefd37287886a550efacf5efc602d89c39adf6c3b7408c6f8fde378b11829e.jpeg",
    "https://cdn.faire.com/fastly/5dd8dbc2c30e40f0542dcb9f8966b32899b6cc7b83ecd12780c052cff68ef39a.jpeg",
  ],
  priceDollars: 14.5,
  description:
    "Carnelian Crystal Mushrooms\n\nThese hand-carved Carnelian mushrooms are the perfect blend of woodland charm and fiery energy. Crafted from natural orange Carnelian, each piece features warm sunset tones ranging from soft honey to deep ember red, with beautiful natural banding.\n\nCarnelian is widely known as a stone of motivation, creativity, and confidence. Often associated with the Sacral Chakra, it’s a favorite for customers seeking energy, inspiration, and bold action. The mushroom shape adds a whimsical, cottagecore aesthetic that fits beautifully in plant displays, fairy-themed décor, altar spaces, and crystal collections.\n\nThese carvings are ideal for:\n• Gift shops\n• Metaphysical stores\n• Plant and garden boutiques\n• Cottagecore / fairycore displays\n\nEach mushroom is unique in color and pattern due to the natural variation of Carnelian. Sizes may vary slightly depending on batch.\n\nA playful, high-sell-through carving that combines approachable price points with strong metaphysical appeal. 🍄🔥\n",
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:06.230Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
